import { IWCCContentBlock, IWCCContentBlockSplitOptions } from "./blocks/block/block.interfaces";
import { WCCContentTextBlock } from "./blocks/text/text";
import { WCCContentBlockFactory } from "./parser.interfaces";

export default class WCCContentDocument {
    blocks: Array<IWCCContentBlock>

    get length() {
        return this.blocks.reduce((length, block) => length + block.length, 0);
    }

    constructor(blocks: Array<IWCCContentBlock>) {
        this.blocks = blocks;
    }

    replace(options: IWCCContentBlockSplitOptions, factory: WCCContentBlockFactory) {
        const newBlocks = this.blocks.flatMap(block => this.merge(block.splitBy(options, factory)))

        return new WCCContentDocument(newBlocks);
    }

    take(maxLength: number) {
        if (maxLength > 0 && this.length > maxLength) {
            const postfix = new WCCContentTextBlock('...');
            const targetLength = maxLength - postfix.length;

            if (targetLength < 0)
                return new WCCContentDocument([]);

            const newBlocks = this.blocks.reduce((result, block) => {
                const availableLength = targetLength - result.length;

                if (availableLength > 0) {
                    const limitedBlock = block.take(availableLength);

                    result.blocks.push(limitedBlock);
                    result.length += limitedBlock.length;

                    if (limitedBlock.length < block.length)
                        result.blocks.push(postfix);
                }

                return result;
            }, { length: 0, blocks: <Array<IWCCContentBlock>>[] }).blocks;

            return new WCCContentDocument(newBlocks);
        }

        return this;
    }

    optimize() {
        this.blocks.reduce((prevBlock, block, idx) => (block.optimize(prevBlock), block), <IWCCContentBlock | undefined>undefined);
    }

    private merge(blocks: Array<IWCCContentBlock>) {
        if (blocks.length <= 1)
            return blocks;

        let newBlocks = blocks;

        do {
            blocks = newBlocks;

            newBlocks = blocks.reduce((result, next) => {
                if (result.length > 0) {
                    const block = <IWCCContentBlock>_(result).last();
                    const newBlock = block.mergeWith(next);

                    if (newBlock != undefined) {
                        result.splice(result.length - 1, 1, newBlock);
                        return result;
                    }
                }

                result.push(next);
                return result;
            }, <Array<IWCCContentBlock>>[]);
        } while (blocks.length !== newBlocks.length);

        return blocks;
    }
}